export const Tools = {
  brush: { id: 'brush', icon: 'Brush' },
  eraser: { id: 'eraser', icon: 'Eraser' }
}
